module.exports = __webpack_public_path__ + "media/images/emoticons/wheelchair-e2af043ac10dcfe5ac44ac60495362d7.gif";